module.exports = __webpack_public_path__ + "img/type_2.a510640e.png";